export default __webpack_public_path__ + "static/media/icoBrands.b865d06d.svg";